import React from "react";
import SnpBillComp from "./SnpBillComp";
import { SnpUIProvider } from "../../global/snpComponent/SnpUiProvider";

export default function RestoBillingModuleV2() {
  return (
    <>
      <SnpUIProvider>
        <SnpBillComp />
      </SnpUIProvider>
    </>
  );
  //UI Corner end
}
